var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "s2w-sequence-selector-wrap" }, [
    _vm.service.rangeSelector.warning
      ? _c("div", {
          staticClass: "message-tip",
          domProps: { innerHTML: _vm._s(_vm.service.rangeSelector.warning) },
        })
      : _vm._e(),
    _c("div", { staticClass: "s2w-sequence-selector" }, [
      _c("div", { staticClass: "s2w-sequence-selector-label" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.$t("BaseSaveToWorkspace.sequence.selected"))),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "range-function-pane" },
        [
          _vm.service.enableRange
            ? [
                _c("div", { staticClass: "use-select" }, [
                  _c(
                    "div",
                    _vm._b(
                      {
                        staticClass: "s2w-range-radio",
                        class: {
                          disabled: _vm.service.disabledAllType,
                          active:
                            _vm.service.rangeSelector.selectedType === "ALL",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeRangeType(
                              "ALL",
                              _vm.service.disabledAllType
                            )
                          },
                        },
                      },
                      "div",
                      _vm.disabledTooltipOption,
                      false
                    ),
                    [
                      _c("div", { staticClass: "s2w-range-radio__dot" }),
                      _c("div", { staticClass: "s2w-range-radio__content" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.selectAllLabel) },
                        }),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "range-container" }, [
                    _c(
                      "div",
                      {
                        staticClass: "s2w-range-radio no-margin",
                        class: {
                          disabled: _vm.service.disabledRangeType,
                          active:
                            _vm.service.rangeSelector.selectedType === "RANGE",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeRangeType(
                              "RANGE",
                              _vm.service.disabledAllType
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "s2w-range-radio__dot" }),
                        _c("div", { staticClass: "s2w-range-radio__content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "range-selector",
                              class: {
                                "is-error": _vm.service.rangeSelector.error,
                              },
                            },
                            [
                              _c("span", { staticClass: "range-label" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "BaseSaveToWorkspace.RangeSelector.from"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("input", {
                                staticClass: "range-input",
                                attrs: {
                                  disabled: _vm.service.disabledRangeType,
                                },
                                domProps: {
                                  value: _vm.service.rangeSelector.from,
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.onRangeInputBlur($event, "from")
                                  },
                                },
                              }),
                              _c("span", { staticClass: "range-label" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "BaseSaveToWorkspace.RangeSelector.to"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("input", {
                                staticClass: "range-input",
                                attrs: {
                                  disabled: _vm.service.disabledRangeType,
                                },
                                domProps: {
                                  value: _vm.service.rangeSelector.to,
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.onRangeInputBlur($event, "to")
                                  },
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "range-error" }, [
                      _vm._v(
                        " " + _vm._s(_vm.service.rangeSelector.error) + " "
                      ),
                    ]),
                  ]),
                  _vm.showRangeTip
                    ? _c(
                        "div",
                        {
                          staticClass: "range-info",
                          attrs: {
                            "aria-label": _vm.$t(
                              "BaseSaveToWorkspace.RangeSelector.tip"
                            ),
                            "data-balloon-pos": "up",
                            "data-balloon-white": "",
                          },
                        },
                        [
                          _c("PtIcon", {
                            staticStyle: { "font-size": "24px" },
                            attrs: { icon: "SolidInfo" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "use-simple" },
                  [
                    _vm._t("simple", function () {
                      return [
                        _vm.sequenceName
                          ? _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.innerSeqName,
                                    expression: "innerSeqName",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "s2w-sequence-selector__input",
                                attrs: { type: "text" },
                                domProps: { value: _vm.innerSeqName },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.innerSeqName =
                                        $event.target.value.trim()
                                    },
                                    _vm.onNameChange,
                                  ],
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ])
                          : _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.selectedCount) +
                                  " " +
                                  _vm._s(
                                    _vm.$t(
                                      "BaseSaveToWorkspace.sequence.selected"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                      ]
                    }),
                  ],
                  2
                ),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }